import toastr from 'toastr';
import 'toastr/build/toastr.min.css'

export function ShowToast(Message: any, Title: any, Type: string, Position: string | undefined = "toast-top-right", 
    showDuration: number | undefined = 1000, 
    hideDuration: number | undefined = 1000,
    timeOut: number | undefined = 5000 
) {
    toastr.options = {
        "closeButton": true,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": (Position == undefined ? "toast-top-right" : Position),
        "preventDuplicates": false,
        "onclick": undefined,
        "showDuration": (showDuration == undefined ? 1000 : showDuration),
        "hideDuration": (hideDuration == undefined ? 1000 : hideDuration),
        "timeOut": (timeOut == undefined ? 5000 : timeOut), 
        "extendedTimeOut": 1000,
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }
    if (Type == 'success') {
        toastr.success(Message, Title);
    } else if (Type == 'error') {
        toastr.error(Message, Title);
    } else if (Type == 'warning') {
        toastr.warning(Message, Title);
    } else if (Type == 'info') {
        toastr.info(Message, Title);
    }
}